var YouLi = YouLi ? YouLi : {};
YouLi.Account = YouLi.Account ? YouLi.Account : {};
YouLi.Account.Register = YouLi.Account.Register ? YouLi.Account.Register : {};

(function (YouLi) {
    (function (Account) {
        (function (Register) {

            YouLi.Account.Register.ToggleMQLFields = function () {
                if ($("#Persona").val().toLowerCase() === "business") {
                    $("#MQLFields").show();
                }
                else {
                    $("#MQLFields").hide();
                }
            };

            YouLi.Account.Register.TogglePlannerFields = function () {
                if ($("#Persona").val().toLowerCase() === "business"
                    || $("#Persona").val().toLowerCase() === "individual") {
                    $("#PlannerFields").show();
                }
                else {
                    $("#PlannerFields").hide();
                }
            };

            YouLi.Account.Register.UpdatePersonaDescription = function () {
                $(".persona-description-text").hide();

                if ($("#Persona").val()) {
                    $("#Persona" + $("#Persona").val()).show();
                }
            };

            YouLi.Account.Register.TogglePasswordShow = function (clickedElement) {
                var inputElement = clickedElement.closest(".form-group").find(".password-field");
                if (inputElement.attr("type") === "password") {
                    inputElement.attr("type", "text");
                } else {
                    inputElement.attr("type", "password");
                }
            };

            $(function () {

                $("#Persona").on("change", function () {
                    YouLi.Account.Register.ToggleMQLFields();
                    YouLi.Account.Register.TogglePlannerFields();
                    YouLi.Account.Register.UpdatePersonaDescription();
                });
                YouLi.Account.Register.ToggleMQLFields();
                YouLi.Account.Register.TogglePlannerFields();
                YouLi.Account.Register.UpdatePersonaDescription();

                $("#Email").focus();

                $(".password-show-link").on("click", function() {
                    YouLi.Account.Register.TogglePasswordShow($(this))
                });

                $(document).on("focus", "#Password", function () {
                    $("#PasswordHelperText").show();
                })

                $(document).on("blur", "#Password", function () {
                    $("#PasswordHelperText").hide();
                });

                $("#RegisterForm").on("submit", function () {
                    document.getElementById("Password").type = "password"; // be sure to reset password type before submitting
                });
            });
        
        }(YouLi.Account.Register ? YouLi.Account.Register : {}));
    }(YouLi.Account ? YouLi.Account : {}));
}(YouLi ? YouLi : {}));